import React from 'react';
import { Select, SelectSizes } from '@clockout-dev/design-elements';
import {
    ENROLLMENT_DATE_CHIP_OPTIONS,
    STAGE_CHIP_OPTIONS,
    PAYROLL_STATUS_CHIP_OPTIONS,
    FILTER_PARAM_KEYS,
} from '../reports.constants';

/**
 * Field group of the Reports filter bar: Enrollment Date, Journey Stage and
 * Payroll (connection status) chips. No title, no
 * footer — those are owned by the container so the same fields can be
 * embedded inside `ReportsFiltersContent` (popover wrapper) or directly
 * inside a `ConfirmModal` (mobile branch).
 *
 * @param {Object} props
 * @param {Object} [props.filters]
 * @param {(name: string, value: any) => void} [props.handleFilterChange]
 * @param {(timeFrame: string) => void} [props.handleTimeFrameChange]
 * @param {(range: any) => void} [props.handleDateRangeChange]
 */
function ReportsFiltersFields({
    filters,
    handleFilterChange,
    handleTimeFrameChange,
    isMobile = false,
}) {
    return (
        <>
            <Select
                size={SelectSizes.SMALL}
                label={isMobile ? "Enrollment Date" : undefined}
                value={filters?.timeFrame || 'all'}
                onChange={(value) => handleTimeFrameChange?.(value)}
                options={ENROLLMENT_DATE_CHIP_OPTIONS}
                searchParamKey={isMobile ? undefined : FILTER_PARAM_KEYS.TIME_FRAME}
            />
            <Select
                size={SelectSizes.SMALL}
                label={isMobile ? "Stage" : undefined}
                value={filters?.stage || 'all'}
                onChange={(value) => handleFilterChange?.('stage', value === 'all' ? null : value)}
                options={STAGE_CHIP_OPTIONS}
                searchParamKey={isMobile ? undefined : FILTER_PARAM_KEYS.STAGE}
            />
            <Select
                size={SelectSizes.SMALL}
                label={isMobile ? "Payroll" : undefined}
                value={filters?.payrollStatus || 'all'}
                onChange={(value) => handleFilterChange?.('payrollStatus', value === 'all' ? null : value)}
                options={PAYROLL_STATUS_CHIP_OPTIONS}
                searchParamKey={isMobile ? undefined : FILTER_PARAM_KEYS.PAYROLL_STATUS}
            />
        </>
    );
}

export default ReportsFiltersFields;
